var map = {
	"./all-products-old.json": "K81n",
	"./all-products-old2.json": "jOml",
	"./all-products.json": "C+hk",
	"./apparel.json": "rzuV",
	"./bags.json": "dVQO",
	"./business.json": "qvef",
	"./drinkware.json": "IMON",
	"./headware.json": "gYl9",
	"./key-rings.json": "xcnc",
	"./leisure.json": "Opnu",
	"./new-products.json": "PDhE",
	"./pens.json": "sa9X",
	"./personal.json": "RLqB",
	"./technology.json": "YQXG",
	"./tools.json": "CdSC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kyAT";